declare global {
	interface Window {
		_NEARPOD_APP: string
	}
}

function isIosApp() {
	return window._NEARPOD_APP && window._NEARPOD_APP === 'IOS'
}

export default isIosApp()
